import $ from 'jquery';
import { WEEKDAYS_SHORT } from './scheduleConfig';
import { dateKey, parseKey, addDays, getAllowedRange } from './dateUtils';

const pad = (n) => String(n).padStart(2, '0');

const navItem = (key, todayKey) => {
    const d = parseKey(key);
    const label = `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${pad(d.getFullYear())}`;
    const cls = 'myScheduleBox__nav-link' + (key === todayKey ? ' is-today' : '');
    return `<li class="myScheduleBox__nav-item">` +
        `<a class="${cls}" href="#" data-action="click->my-schedule#scrollToDay:prevent" data-my-schedule-day-param="${key}">${label}</a>` +
        `</li>`;
};

/** Перерисовывает навигацию по списку загруженных дней (loadedDays) */
export function renderNavigator(days) {
    const todayKey = dateKey(new Date());
    const $nav = $('#myScheduleBoxNav');
    const left = $nav.scrollLeft();            // иначе горизонтальный скролл навигации сбрасывается
    $nav.html(days.map((key) => navItem(key, todayKey)).join(''));
    $nav.scrollLeft(left);
}

/** Плавный скролл к блоку дня */
export function scrollToDayBlock(key) {
    document.getElementById('myScheduleBox-' + key)
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/** Кнопка "Применить" у поля даты */
export function toggleApply(show) {
    $('#myScheduleApplyBtn').toggleClass('d-none', !show);
}

/** Загрузка / перезагрузка всего списка */
export function setLoading(on) {
    $('#myScheduleLoader').toggleClass('d-none', !on);
    $('#myScheduleDay').toggleClass('is-loading', on);
}

/** Подгрузка следующего дня внизу */
export function setMoreLoading(on) {
    $('#myScheduleMoreLoader').toggleClass('d-none', !on);
}

/** Достигнут конец допустимого диапазона */
export function setEndReached(on) {
    $('#myScheduleEnd').toggleClass('d-none', !on);
}
